<div>
	{{ cellValue }} {{ suffix }}
</div>